import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	UpdateContributionAmount,
	type UpdateContributionAmountMutation,
	type UpdateContributionAmountMutationVariables,
} from './updateContributionAmount.graphql';

export type UpdateContributionAmountResult = { success: boolean };

export async function updateContributionAmount(
	{
		amount,
		id,
		currency,
	}: {
		amount: number;
		id: string;
		currency: string;
	},
	{ gql: { fetch } }: UtilityContext,
): Promise<UpdateContributionAmountResult> {
	try {
		const { data } = await fetch<UpdateContributionAmountMutation, UpdateContributionAmountMutationVariables>({
			query: UpdateContributionAmount,
			variables: {
				input: {
					amount,
					id,
					currency,
				},
			},
			rejectOnError: true,
		});

		if (data.modifySubscription.result !== 'SUCCESS') {
			return { success: false };
		}
		return { success: true };
	} catch (e) {
		return { success: false };
	}
}
